import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { RoleGuard } from './core/guards/role.guard';
import { LayoutComponent } from './shared/components/layout/layout.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'my-teams',
        loadChildren: () => import('./features/my-teams/my-teams.module').then(m => m.MyTeamsModule)
      },
      {
        path: 'profile',
        loadChildren: () => import('./features/profile/profile.module').then(m => m.ProfileModule)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./features/notifications/notifications.module').then(m => m.NotificationsModule)
      },
      {
        path: 'global-admin',
        loadChildren: () => import('./features/global-admin/global-admin.module').then(m => m.GlobalAdminModule)
      },
      {
        path: 'admin',
        loadChildren: () => import('./features/admin/admin.module').then(m => m.AdminModule)
      },
      {
        path: 'users',
        loadChildren: () => import('./features/users/users.module').then(m => m.UsersModule)
      },
      // TEAM CONTEXT ROUTES
      {
        path: 'teams',
        loadChildren: () => import('./features/teams/teams.module').then(m => m.TeamsModule)
      },
      {
        path: 'motorcycles',
        redirectTo: 'vehicles',
        pathMatch: 'full'
      },
      {
        path: 'vehicles',
        children: [
          {
            path: '',
            loadChildren: () => import('./features/vehicles/vehicles.module').then(m => m.VehiclesModule)
          },
          // VEHICLE CONTEXT ROUTES (vehicle-specific features)
          {
            path: ':vehicleId/overview',
            loadChildren: () => import('./features/vehicle-overview/vehicle-overview.module').then(m => m.VehicleOverviewModule)
          },
          {
            path: ':vehicleId/training',
            loadChildren: () => import('./features/training/training.module').then(m => m.TrainingModule)
          },
          {
            path: ':vehicleId/rodadas',
            loadChildren: () => import('./features/rodadas/rodadas.module').then(m => m.RodadasModule)
          },
          {
            path: ':vehicleId/telemetry',
            loadChildren: () => import('./features/telemetry/telemetry.module').then(m => m.TelemetryModule)
          },
          {
            path: ':vehicleId/vehicle-control',
            loadChildren: () => import('./features/vehicle-control/vehicle-control.module').then(m => m.VehicleControlModule)
          },
          {
            path: ':vehicleId/diagnostics',
            loadChildren: () => import('./features/diagnostics/diagnostics.module').then(m => m.DiagnosticsModule)
          },
          {
            path: ':vehicleId/assembly-manuals',
            loadChildren: () => import('./features/assembly-manuals/assembly-manuals.module').then(m => m.AssemblyManualsModule)
          }
        ]
      },
      // Legacy routes (backward compatibility - redirect to vehicle context)
      {
        path: 'training',
        redirectTo: 'vehicles',
        pathMatch: 'full'
      },
      {
        path: 'rodadas',
        redirectTo: 'vehicles',
        pathMatch: 'full'
      },
      {
        path: 'telemetry',
        redirectTo: 'vehicles',
        pathMatch: 'full'
      },
      {
        path: 'vehicle-control',
        redirectTo: 'vehicles',
        pathMatch: 'full'
      },
      {
        path: 'diagnostics',
        redirectTo: 'vehicles',
        pathMatch: 'full'
      },
      {
        path: 'delivery',
        loadChildren: () => import('./features/delivery/delivery.module').then(m => m.DeliveryModule)
      },
      {
        path: 'invoicing',
        loadChildren: () => import('./features/invoicing/invoicing.module').then(m => m.InvoicingModule)
      },
      {
        path: 'financial',
        loadChildren: () => import('./features/financial/financial.module').then(m => m.FinancialModule)
      },
      {
        path: 'inventory',
        loadChildren: () => import('./features/inventory/inventory.module').then(m => m.InventoryModule)
      },
      {
        path: 'calendar',
        loadChildren: () => import('./features/calendar/calendar.module').then(m => m.CalendarModule)
      },
      {
        path: 'events',
        loadChildren: () => import('./features/events/events.module').then(m => m.EventsModule)
      },
      {
        path: 'trips',
        loadChildren: () => import('./features/trips/trips.module').then(m => m.TripsModule)
      },
      {
        path: 'tasks',
        loadChildren: () => import('./features/tasks/tasks.module').then(m => m.TasksModule)
      },
      {
        path: 'documents',
        loadChildren: () => import('./features/documents/documents.module').then(m => m.DocumentsModule)
      },
      {
        path: 'assembly-manuals',
        loadChildren: () => import('./features/assembly-manuals/assembly-manuals.module').then(m => m.AssemblyManualsModule)
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/dashboard'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
